.container {
  justify-content: flex-end;
  gap: 4px;
  display: flex;
}

.linkContent {
  cursor: pointer;
  color: var(--tuna-palette-text-secondary);
  display: inline-flex;
}

.nameSpan {
  margin-left: 4px;
  margin-right: 0;
}

.launchIcon {
  align-self: end;
  transform: scale(0.7);
}
